import React, { Component } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  Tr,
  Td,
  Table,
  Thead,
  Th,
  Tbody,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import {
  HamburgerIcon,
  ChevronDownIcon,
  LinkIcon,
  CalendarIcon,
} from "@chakra-ui/icons";
import { v4 as uuidv4 } from "uuid";
import * as objs from "../../objs";
import ShowTbl from "./nosql/showTbls";

import SortPermissions from "./permissions";

class Admin extends Component {
  state = { lstDb: [], isOpen: false, selectedTitle: "", panelId: 0 };

  componentDidMount() {
    this.addMoreListeners();
  }

  async addMoreListeners() {
    this.props.chatSocket.on("showDBNames", (data) => {
      var j = JSON.parse(data);
      this.setState({ lstDb: j });
    });

    this.props.chatSocket.emit(
      "getDBInfo",
      JSON.stringify({ cmd: "all", db: "", coll: "" })
    );
    //this.props.chatSocket.emit("getDBInfo", JSON.stringify({cmd: "coll",db:"transportdrivertrainingcomau",coll:""}));
  }

  async btnPressMenu(id) {
    if (id == 1) {
      this.setState({
        panelId: 1,
        isOpen: true,
        selectedTitle: "NoSql DB Manager",
      });
    } else if (id == 2) {
      this.setState({
        panelId: 2,
        isOpen: true,
        selectedTitle: "Permissions",
      });
    }
  }

  getDBmanager() {
    const { lstDb } = this.state;
    var lstDbTabs = lstDb.map((userData) => (
      <Tab key={uuidv4()} className="uiq_tr" colorScheme="teal">
        <Stack>
          <Text>Name: {userData[0]}</Text>
          <Text>TBls: {userData[1].length}</Text>
        </Stack>
      </Tab>
    ));

    var lstDBTabPanel = [];

    for (var p in lstDb) {
      //console.log(lstDb[p]);

      lstDBTabPanel.push(<TabPanel>{<ShowTbl tbl={lstDb[p]} />}</TabPanel>);
    }

    return (
      <Stack>
        <Tabs variant="soft-rounded" colorScheme="green">
          <TabList>{lstDbTabs}</TabList>
          <TabPanels>{lstDBTabPanel}</TabPanels>
        </Tabs>
      </Stack>
    );
  }

  getPermissionsManager() {
    return <SortPermissions chatSocket={this.props.chatSocket} />;
  }

  getPanel() {
    const { panelId } = this.state;

    var content = <></>;
    switch (panelId) {
      case 1:
        content = this.getDBmanager();
        break;
      case 2:
        content = this.getPermissionsManager();
        break;
    }
    return content;
  }

  render() {
    const { isOpen, selectedTitle } = this.state;

    return (
      <WrapItem>
        <Drawer placement="top" isOpen={isOpen} size="full">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader>
              <Button onClick={() => this.setState({ isOpen: false })}>
                Back
              </Button>{" "}
              {selectedTitle}
            </DrawerHeader>
            <DrawerBody>{this.getPanel()}</DrawerBody>
          </DrawerContent>
        </Drawer>
        <Menu>
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            h="60px"
            colorScheme="teal"
          >
            Admin
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => this.btnPressMenu(2)}>
              Permissions
            </MenuItem>
            <MenuItem onClick={() => this.btnPressMenu(1)}>
              NoSql DB Manager
            </MenuItem>
          </MenuList>
        </Menu>
      </WrapItem>
    );
  }
}

export default Admin;
